import React from 'react'
import RichText, { IRichText } from '../RichText'
import { TextComponentProps } from './Text.types'
import CardComponent from '../Card'
import HelpImage from '../Image/Variants/HelpImage'
import Form from '../Form'
import CallToAction from '../CallToAction'
import AccordionComponent from '../Accordion'
import CodeModule from '../CodeModule'
import { ContentfulToComponent, ContentfulToComponentProps } from '../RichText/types'

const TextComponent: React.FC<TextComponentProps> = ({ text }) => {
  const propsMap: Partial<ContentfulToComponentProps> = {
    HelpUniverseComponentCard: <CardProps,>(props: CardProps) => ({
      ...(props as unknown as CardProps),
    }),
    HelpUniverseComponentImage: <HelpImageProps,>(props: HelpImageProps) => ({
      ...(props as unknown as HelpImageProps),
    }),
    HelpUniverseModuleForm: <FormProps,>(props: FormProps) => ({
      ...(props as unknown as FormProps),
    }),
    HelpUniverseComponentCta: <CallToActionType,>(props: CallToActionType) => ({
      ...(props as unknown as CallToActionType),
    }),
    HelpUniverseComponentAccordion: <AccordionComponentProps,>(props: AccordionComponentProps) => ({
      ...(props as unknown as AccordionComponentProps),
    }),
    HelpUniverseModuleDynamicComponents: <CodeModuleComponentProps,>(props: CodeModuleComponentProps) => ({
      ...(props as unknown as CodeModuleComponentProps),
    }),
  } as const

  const textComponentMap: Partial<ContentfulToComponent> = {
    'HelpUniverseComponentCard': CardComponent,
    'HelpUniverseComponentImage': HelpImage,
    'HelpUniverseModuleForm': Form,
    'HelpUniverseComponentCta': CallToAction,
    'HelpUniverseComponentAccordion': AccordionComponent,
    'HelpUniverseModuleDynamicComponents': CodeModule,
  } as const
  return (
    <RichText
      {...(text as IRichText)}
      componentMap={textComponentMap as ContentfulToComponent}
      propsMap={propsMap as ContentfulToComponentProps}
    />
  )
}

export default TextComponent
